import React, { useEffect } from 'react';

import { REGION, HEAP_REGIONS } from './regions';
import { initOptimizelyCohortTracking } from './utils/heapTracker';
import { sendHeldCioEvents } from './utils/analytics/destinations/customerio';

const cleanUrlParams = (excludeKeys: string[] = []) => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  excludeKeys.forEach((key) => params.delete(key));
  if (typeof window !== 'undefined') {
    window.history.replaceState(null, '', `${url.pathname}?${params}`);
  }
};

export function usePageSetup() {
  useEffect(() => {
    cleanUrlParams(['plan', 'sub_coupon', 'source', 'express_checkout_layout']);
    sendHeldCioEvents();
    if (HEAP_REGIONS.includes(REGION)) {
      initOptimizelyCohortTracking();
    }
  }, []);
}
